<template>
  <basic-layout>
    <router-view />
  </basic-layout>
</template>

<script>
import firebase from 'firebase/app'
import BasicLayout from './layouts/Basic'
import { useUsersStore } from '@/stores/users'
import '@/db'

export default {
  name: 'App',
  components: {
    BasicLayout,
  },
  data() {
    return {
      users: useUsersStore(),
    }
  },
  mounted() {
    this.subscribeUserState()
  },
  unmounted() {
    this.unsubscribeUserState()
  },
  methods: {
    subscribeUserState() {
      const users = this.users
      this.unsubscribeUserStateFunction = firebase
        .auth()
        .onAuthStateChanged(function (user) {
          if (user) {
            users.user = user
          }
          users.isFetchingUser = false
        })
    },
    unsubscribeUserState() {
      if (this.unsubscribeUserStateFunction) {
        this.unsubscribeUserStateFunction()
      }
    }
  }
}
</script>
